import { Controller } from "@hotwired/stimulus";
import { Spinner } from "spin.js";

export default class extends Controller {
    connect() {
        new Spinner().spin(this.element);
    }
}